export default __webpack_public_path__ + "static/15-6982cb5596cb04864c88cfe268739a5c.png";